import React from 'react';
import { useParams } from 'react-router-dom';
import ContactView from './ContactView';

const ContactViewForUpdating: React.FC = () => {
  const { contactId } = useParams<{ contactId: string }>();

  return <ContactView initialMode="update" contactId={contactId} />;
};

export default ContactViewForUpdating;
